import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import holiday from "../../../containers/modules/hr/holiday";

export default function HolidayRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="holiday"
      index
      element={
        <AccessControl
          name={"Holiday List"}
          auth={authUser}
          component={holiday}
        />
      }
    ></Route>
  );
}
